export default "__VITE_ASSET__a424babb__"